import React, { useEffect, useState } from 'react';
import { useParams, Link as RouterLink } from 'react-router-dom';
import { Box, Button, CircularProgress, Alert, Container, Card, CardContent } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import axios from 'axios';
import { publicApiUrl } from '../../utils/publicApi';
import { PublicJobDetailBody } from './PublicJobDetailView';

const PublicJobDetail = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [job, setJob] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    let c = false;
    (async () => {
      try {
        const r = await axios.get(publicApiUrl(`/jobs/${id}`));
        if (c) return;
        setJob(r.data?.data);
      } catch (e) {
        if (!c) setError(e.response?.data?.message || 'Job not found.');
      } finally {
        if (!c) setLoading(false);
      }
    })();
    return () => {
      c = true;
    };
  }, [id]);

  if (loading) {
    return (
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Box display="flex" justifyContent="center" py={6}>
          <CircularProgress />
        </Box>
      </Container>
    );
  }

  if (error || !job) {
    return (
      <Container maxWidth="lg" sx={{ py: 3 }}>
        <Alert severity="warning">{error || 'Not available.'}</Alert>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 3 }}>
      <Button component={RouterLink} to="/query#portal-jobs" startIcon={<ArrowBackIcon />} sx={{ mb: 2 }}>
        Back to public portal
      </Button>
      <Card variant="outlined">
        <CardContent>
          <PublicJobDetailBody job={job} />
        </CardContent>
      </Card>
    </Container>
  );
};

export default PublicJobDetail;
